<div class="managements-container">
  <h2>Managements</h2>
  <div class="managements-grid">
    @for (feature of features(); track feature) {
      <div
        class="management-card"
        [routerLink]="feature.navCommands[0]"
        tabindex="0"
        role="button"
        >
        <span class="material-symbols-outlined management-icon">
          {{ feature.icon }}
        </span>
        <div class="management-title">{{ feature.name }}</div>
      </div>
    }
  </div>
</div>
